(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["statera-mini-collection"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  const video = document.querySelector(".statera-background__video");
  if (!video) return;

  // Ensure video can play programmatically
  video.muted = true;
  video.play().catch(() => {});

  video.addEventListener("loadedmetadata", () => {
    gsap.registerPlugin(ScrollTrigger);

    let proxy = { t: 0 }; // proxy object
    let duration = video.duration;

    gsap.to(proxy, {
      t: duration,
      ease: "none",
      scrollTrigger: {
        trigger: ".statera-mini-collection",
        start: "top bottom",
        end: "bottom top",
        scrub: true,
      },
      onUpdate: () => {
        video.currentTime = proxy.t;
      }
    });
  });
});

  } catch(e) { console.error(e); }
})();
})();
